import { catchError, timeout } from "rxjs";
import { WawiConnectorExecutable, WawiConnectorType, WawiConnectorTypeExecutable } from "../wawi-connector.types";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { HttpFunctionResult } from "src/app/_interfaces/HttpFunctionResult";


export class WebConnectorService implements WawiConnectorExecutable{

    public executable: true = true;
    public type: WawiConnectorTypeExecutable = WawiConnectorType.WEBCONNECTOR;

    constructor(
        private http: HttpClient,
        private port: number = 8095
    ){
    }

    public static async isAvailable(http: HttpClient, port: number = 8095): Promise<boolean>{
        const connector: WebConnectorService = new WebConnectorService(http, port);
        const result: HttpFunctionResult<boolean> = await connector.executeCommand("api/Manager");
        return result.success
    }

    public async executeCommand(command: string): Promise<HttpFunctionResult<any>> {
        return new Promise(resolve=>{
            const header: HttpHeaders = new HttpHeaders({ 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'disabled-no-response-handler': "true"
            })

            this.http.get(`http://localhost:${this.port ?? 8095}/${command}`, { headers: header, observe: "response"})
            .pipe(
                timeout(15000),
                catchError(async (err: HttpErrorResponse)=> { throw err })
            )
            .subscribe({
                next: (res: (HttpResponse<any>))=> resolve({ success: true, data: res.status }),
                error: (error: HttpErrorResponse)=>resolve({
                    success: false,
                    data: error.status,
                    message: this.getErrorMessage(error)
                })
            })
        })
    }
    public async openArticle(articleId: number): Promise<HttpFunctionResult> {
        return await this.executeCommand(`api/Manager/OpenArticle/${articleId}`)
    }
    public async openCustomer(customerId: number): Promise<HttpFunctionResult> {
        return await this.executeCommand(`api/Manager/OpenAddress/${customerId}`)
    }
    public async openProcess(processId: number): Promise<HttpFunctionResult> {
        return await this.executeCommand(`api/Manager/OpenAuftrag/${processId}`)
    }

    /**
     * Holte die Fehlermeldung aus einem Fehler-Objekt
     * @param {HttpErrorResponse} error Fehler-Object
     * @returns {string} die Fehlermeldung
     */
    private getErrorMessage(error: HttpErrorResponse): string{
        return error?.error?.error ?? error?.error?.error?.message ?? error?.error?.message ?? error?.error?.detail ?? error?.message ?? error?.error ??  "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal."
    }

}